/**
 * Dress Junction Custom Header JavaScript - FINAL VERSION
 * Fixed mega menu hover with longer delays
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ===========================
  // Mobile Drawer Functionality
  // ===========================
  
  const drawer = document.querySelector('[data-drawer]');
  const toggleBtn = document.querySelector('[data-drawer-toggle]');
  const closeBtn = document.querySelector('[data-drawer-close]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  
  function openDrawer() {
    if (!drawer) return;
    
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'true');
    }
    
    if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 100);
    }
  }
  
  function closeDrawer() {
    if (!drawer) return;
    
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.focus();
    }
  }
  
  if (toggleBtn) {
    toggleBtn.addEventListener('click', openDrawer);
  }
  
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }
  
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
  
  
  // ===========================
  // Desktop Mega Menu - FIXED WITH LONGER DELAYS
  // ===========================
  
  const navItems = document.querySelectorAll('.dj-nav-item--has-dropdown');
  let closeTimeout;
  let currentOpenItem = null;
  
  navItems.forEach(item => {
    const link = item.querySelector('.dj-nav-link');
    const megaMenuWrapper = item.querySelector('.dj-mega-menu-wrapper');
    
    if (!link || !megaMenuWrapper) return;
    
    // Prevent default on mobile
    link.addEventListener('click', function(e) {
      if (window.innerWidth < 990) {
        e.preventDefault();
      }
    });
    
    // Show immediately on hover
    item.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 990) {
        clearTimeout(closeTimeout);
        
        // Close other menus
        if (currentOpenItem && currentOpenItem !== item) {
          const otherLink = currentOpenItem.querySelector('.dj-nav-link');
          if (otherLink) {
            otherLink.setAttribute('aria-expanded', 'false');
          }
        }
        
        link.setAttribute('aria-expanded', 'true');
        currentOpenItem = item;
      }
    });
    
    // Hide with LONG DELAY (500ms)
    item.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        closeTimeout = setTimeout(() => {
          link.setAttribute('aria-expanded', 'false');
          if (currentOpenItem === item) {
            currentOpenItem = null;
          }
        }, 500); // LONG DELAY
      }
    });
    
    // Keep open when hovering dropdown
    megaMenuWrapper.addEventListener('mouseenter', function() {
      if (window.innerWidth >= 990) {
        clearTimeout(closeTimeout);
        link.setAttribute('aria-expanded', 'true');
        currentOpenItem = item;
      }
    });
    
    // Close with delay when leaving dropdown
    megaMenuWrapper.addEventListener('mouseleave', function() {
      if (window.innerWidth >= 990) {
        closeTimeout = setTimeout(() => {
          link.setAttribute('aria-expanded', 'false');
          if (currentOpenItem === item) {
            currentOpenItem = null;
          }
        }, 500); // LONG DELAY
      }
    });
    
    // Keyboard navigation
    link.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        link.setAttribute('aria-expanded', !isExpanded);
        currentOpenItem = !isExpanded ? item : null;
      }
      
      if (e.key === 'Escape') {
        link.setAttribute('aria-expanded', 'false');
        currentOpenItem = null;
        link.focus();
      }
    });
  });
  
  
  // ===========================
  // Mobile Accordion
  // ===========================
  
  const mobileDetails = document.querySelectorAll('.dj-mobile-menu__details, .dj-mobile-submenu__details');
  
  mobileDetails.forEach(details => {
    details.addEventListener('toggle', function() {
      if (this.open) {
        const parent = this.parentElement;
        const siblings = parent.querySelectorAll(':scope > .dj-mobile-menu__item > .dj-mobile-menu__details[open], :scope > .dj-mobile-submenu__item > .dj-mobile-submenu__details[open]');
        
        siblings.forEach(sibling => {
          if (sibling !== this) {
            sibling.open = false;
          }
        });
      }
    });
  });
  
  
  // ===========================
  // Sticky Header Scroll Effect
  // ===========================
  
  const header = document.getElementById('dj-header');
  const headerWrapper = document.querySelector('.dj-header-wrapper');
  
  if (header && headerWrapper) {
    let lastScrollTop = 0;
    let ticking = false;
    
    function handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Add scrolled class for visual changes
      if (scrollTop > 50) {
        header.classList.add('dj-header--scrolled');
        header.classList.add('is-scrolled');
        headerWrapper.classList.add('scrolled');
      } else {
        header.classList.remove('dj-header--scrolled');
        header.classList.remove('is-scrolled');
        headerWrapper.classList.remove('scrolled');
      }
      
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    
    // Optimized scroll with requestAnimationFrame
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    
    // Initial state
    handleScroll();
  }
  
  
  // ===========================
  // Close Dropdowns on Outside Click
  // ===========================
  
  document.addEventListener('click', function(e) {
    const isNavClick = e.target.closest('.dj-nav-item');
    const isMegaMenuClick = e.target.closest('.dj-mega-menu-wrapper');
    
    if (!isNavClick && !isMegaMenuClick && window.innerWidth >= 990) {
      clearTimeout(closeTimeout);
      navItems.forEach(item => {
        const link = item.querySelector('.dj-nav-link');
        if (link) {
          link.setAttribute('aria-expanded', 'false');
        }
      });
      currentOpenItem = null;
    }
  });
  
  
  // ===========================
  // Resize Handler
  // ===========================
  
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Close drawer on desktop
      if (window.innerWidth >= 990 && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
      
      // Close all mega menus
      navItems.forEach(item => {
        const link = item.querySelector('.dj-nav-link');
        if (link) {
          link.setAttribute('aria-expanded', 'false');
        }
      });
      currentOpenItem = null;
    }, 250);
  });
  
});